import QuemEQuem from '../../pages/quemEQuem';
import EditarUsuario from '../../pages/usuario/editarUsuario';
import VisualizarUsuario from '../../pages/usuario/visualizarUsuario';
import Reunioes from '../../pages/reunioes';
import ConsultarBiblioteca from '../../pages/biblioteca/consultar'
import EditarReunioes from "../../pages/reunioes/editarReuniao";
import CadastrarReuniao from "../../pages/reunioes/cadastrarReuniao";
import VisualizarReuniao from "../../pages/reunioes/visualizarReuniao";
import Formularios from '../../pages/formularios';
import CadastrarDuplicarFormulario from '../../pages/formularios/cadastrarDuplicarFormulario';
import VisualizarFormulario from '../../pages/formularios/visualizarFormulario';
import EditarFormulario from '../../pages/formularios/editarFormulario';

const indexRoutes = [
  { path: '/usuario/:id', component: VisualizarUsuario },
  { path: '/usuario/:id/editar', component: EditarUsuario },
  { path: '/quem-e-quem', component: QuemEQuem },
  { path: '/biblioteca', component: ConsultarBiblioteca },
  { path: '/formularios', component: Formularios },
  { path: '/formulario', component: CadastrarDuplicarFormulario },
  { path: '/formulario/:id/editar', component: EditarFormulario },
  { path: '/formulario/:id/visualizar', component: VisualizarFormulario },
  { path: '/reunioes', component: Reunioes },
  { path: '/reuniao', component: CadastrarReuniao },
  { path: '/reuniao/:id/visualizar', component: VisualizarReuniao },
  { path: '/reuniao/:id/editar', component: EditarReunioes },
];

export default indexRoutes;
